import React, { Dispatch, SetStateAction, useState } from 'react';
import { ArrowBackIcon, CancelLinkingIcon } from '../../../../components/icons';
import Button from '../../../../components/button/Button';

const ConnectErrorScreen = ({
    onClose,
    prevStep,
    setStep
}: {
    onClose: () => void;
    setStep: Dispatch<SetStateAction<1 | 2 | 3 | 4>>;
    prevStep: 1 | 2 | 3 | 4 | undefined;
}) => {
    const [finalClose, setFinalClose] = useState(false);

    return (
        <div className='h-[423px] flex flex-col justify-center items-center'>
            <CancelLinkingIcon color={finalClose ? '#B42318' : undefined} />
            <p className='text-ebony text-[20px] leading-[30px] mt-[40px] mb-4  max-w-[238px] text-center'>
                {finalClose
                    ? 'Account linking cancelled'
                    : 'Cancel Account Linking?'}
            </p>
            <p className='text-gray200 text-[14px] leading-[20px] mb-[24px] max-w-[296px] text-center'>
                {finalClose
                    ? 'Your account linking was cancelled successfully.'
                    : 'You’ll lose any progress made. You can restart the process from the dashboard.'}
            </p>

            {finalClose ? (
                <Button
                    text='Return to dashboard'
                    leftIcon={<ArrowBackIcon color='white' />}
                    className='w-full max-w-[350px]'
                    onClick={() => {
                        setStep(prevStep || 1);
                        onClose();
                    }}
                />
            ) : (
                <div className='flex w-full max-w-[350px] mt-4 gap-4'>
                    <Button
                        text='No'
                        variant='secondaryOutline'
                        className='flex-1'
                        onClick={() => setStep(prevStep || 1)}
                    />
                    <Button
                        text='Yes'
                        className='flex-1'
                        onClick={() => {
                            setFinalClose(true);
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default ConnectErrorScreen;
